/**
 * Migrated to TypeScript
 */
import App from '../app.js';
import GetCitiesResponse from './dto/response/GetCitiesResponse';

interface ICitiesService {
  getCities(state: string): ng.IPromise<GetCitiesResponse>;
}

class CitiesService implements ICitiesService {
  private baseUrl: string;

  constructor(
    private $http: ng.IHttpService,
    private $location: ng.ILocationService
  ) {
    const absUrl = this.$location.absUrl();
    this.baseUrl = absUrl.substring(0, absUrl.indexOf('#'));
  }

  getCities(state: string): ng.IPromise<GetCitiesResponse> {
    return this.$http
      .get(`${this.baseUrl}pictureDayFinder/getCityForEnroll/${state}`, {})
      .then((response: ng.IHttpResponse<any>) => {
        return GetCitiesResponse.fromApiResponse(response.data);
      })
      .catch(() => {
        // Return a failed response with empty accounts array
        return new GetCitiesResponse(false, [], [], []);
      });
  }
}

App.service('CitiesService', ['$http', '$location', CitiesService]);

export default CitiesService;
